const tab_home = () =>
  import( /* webpackChunkName: "tabbar-home" */ '@/views/home/tabbar-home.vue');
const Tabbar = () =>
  import( /* webpackChunkName: "Tabbar" */ '@/vue/components/Tabbar/');
const crowdbuy = () =>
  import("@/vue/components/crowdbuy/index.vue");
const nodata = () =>
  import("@/views/home/nodata.vue");

export default [{
  path: "/",
  name: "home",
  components: {
    default: tab_home,
    // tabbar: Tabbar
  },
  meta: {
    keepAlive: true,
    title: "AIA gift",
    // titleNView: true,
  }
},
// {
// 	path: "/",
// 	name: "home",
// 	components: {
//     default: tab_home,
// 	},
// 	meta: {
// 		keepAlive: true
// 	},

// },
{
  path: "/crowdbuy",
  name: "crowdbuy",
  components: {
    default: crowdbuy
  },
  meta: {
    title: "团购"
  }
},
{
  path: "/nodata",
  name: "nodata",
  components: {
    default: nodata
  },
  meta: {
    title: "暂无数据"
  }
}
]
